import { Text, TooltipOnHover } from 'tombac';
import { WarningIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
export const SharedLimitWarning = () => /*#__PURE__*/_jsx(Text, {
  as: "div",
  $alignSelf: "center",
  $ml: "1sp",
  fontSize: 14,
  "data-sentry-element": "Text",
  "data-sentry-component": "SharedLimitWarning",
  "data-sentry-source-file": "limitEditorElements.tsx",
  children: /*#__PURE__*/_jsx(TooltipOnHover, {
    content: "Already set in shared limits",
    placement: "top",
    size: "s",
    variant: "inverted",
    "data-sentry-element": "TooltipOnHover",
    "data-sentry-source-file": "limitEditorElements.tsx",
    "data-sentry-element": "TooltipOnHover",
    children: /*#__PURE__*/_jsx(WarningIcon, {
      "data-sentry-element": "WarningIcon",
      "data-sentry-source-file": "limitEditorElements.tsx",
      "data-sentry-element": "WarningIcon"
    })
  })
});